module.exports = __webpack_public_path__ + "static/media/prod10-bg.ca635ea2.png";